module.exports = __webpack_public_path__ + "static/media/amex.876667e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/RegisterExtension/OrderPaymentForm/CreditCardFields/cardImages/amex.svg
// module id = 1035
// module chunks = 1